<template>
  <div
    :style="{width: $isMobile? '98%' : '800px', margin: '0 auto 170px', overflowY: 'auto'}"
    class='message-list grow pa-1' ref='messageList'>
    <div v-for='(message, index) in messages' :key='index'
         :class="['message', message.sender]">
      <div
        class='mb-4 text-wrap py-2 rounded-xl d-inline-block'>
        <div class='d-flex flex-column align-start'>
          <v-avatar
            v-if="message.sender === 'bot' && !message.hideAvatar"
            tile
            class='mr-2 mb-2'
            color='#fbf6fe'
            :size="$isMobile ? 30 : 38"
          >
            <img
              :src="require('@/assets/images/avatars/cssa_bot.png')"
              alt=''
            />
          </v-avatar>
          <div :style="{marginLeft: message.hideAvatar ? '45px' : ''}">
            <div v-if="message.type === 'render'">
              <message-prompt
                v-if="message.sender === 'bot' && message.msg === 'messagePrompt'"
                :message="message.errorMag"
                :prompt-title="message.promptTitle"
              ></message-prompt>

              <CancelBookedNoticeCard
                v-if="message.sender === 'bot' && message.msg === 'cancelBookedNotice' && !$isMobile"
                :item='message'
                :language="message.language"
              ></CancelBookedNoticeCard>

              <CancelBookedNoticeCardMobile
                v-if="message.sender === 'bot' && message.msg === 'cancelBookedNotice' && $isMobile"
                :item='message'
                :language="message.language"
              ></CancelBookedNoticeCardMobile>

              <ErrorBookedNoticeCardMobile
                v-if="message.sender === 'bot' && message.msg === 'errorBookedNotice' && $isMobile"
                :item='message'
                :language="message.language"
              ></ErrorBookedNoticeCardMobile>

              <BookedRoom
                v-if="message.sender === 'bot' && message.msg === 'bookedMeetingRooms' && !$isMobile"
                :roomList='message.places'
                :language="message.language"
                :item='message'
                @cancelBookingCompletedEmit='cancelBookingCompletedEmit'
              ></BookedRoom>

              <BookedRoomMobile
                v-if="message.sender === 'bot' && message.msg === 'bookedMeetingRooms' && $isMobile"
                :roomList='message.places'
                :language="message.language"
                :item='message'
                @cancelBookingCompletedEmit='cancelBookingCompletedEmit'
              ></BookedRoomMobile>

              <BookingAwaitingApprovalMobile
                v-if="message.sender === 'bot' && message.msg === 'awaitingApproval' && $isMobile"
                :item='message'
                :language="message.language"
                @cancelBookingCompletedEmit='cancelBookingCompletedEmit'
              >
              </BookingAwaitingApprovalMobile>
              <BookingAwaitingApproval
                v-if="message.sender === 'bot' && message.msg === 'awaitingApproval' && !$isMobile"
                :item='message'
                :language="message.language"
                @cancelBookingCompletedEmit='cancelBookingCompletedEmit'
              ></BookingAwaitingApproval>
              <booking-success
                v-if="message.sender === 'bot' && message.msg === 'bookingSuccess' && !$isMobile"
                :item='message'
                :language="message.language"
                @cancelBookingCompletedEmit='cancelBookingCompletedEmit'
              >
              </booking-success>
              <BookingSuccessMobile
                v-if="message.sender === 'bot' && message.msg === 'bookingSuccess' && $isMobile"
                :item='message'
                :language="message.language"
                @cancelBookingCompletedEmit='cancelBookingCompletedEmit'>
              </BookingSuccessMobile>
              <city-select
                v-if="message.sender === 'bot' && message.msg === 'cityComponent'"
                :list='message.cityList'
                :msg-id='message.msgId'
                :language="message.language"
                :message-data='message'
                :immediately-render='message.immediatelyRender'
                @refreshAnswer='refreshAnswer(message)'
                @selectCityChange='selectCityChange'
                @cancelChat="(val) => $emit('cancelChat', val)"
              >
              </city-select>
              <ragDatePicker
                v-else-if="message.supportLike && message.sender === 'bot' && message.msg === 'ragDatePicker' && !$isMobile"
                :index='index'
                :msg-id='message.msgId'
                @submit='getDataRange'
                :language="message.language"
                :start-time='message.startDateTime'
                :end-time='message.endDateTime'
                :message-data='message'
                :immediately-render='message.immediatelyRender'
                @cancelChat="(val) => $emit('cancelChat', val)"
              >
              </ragDatePicker>

              <ragDatePickerMobile
                v-else-if="message.supportLike && message.sender === 'bot' && message.msg === 'ragDatePicker' && $isMobile"
                :index='index'
                :msg-id='message.msgId'
                @submit='getDataRange'
                :language="message.language"
                :start-time='message.startDateTime'
                :end-time='message.endDateTime'
                :message-data='message'
                :immediately-render='message.immediatelyRender'
                @cancelChat="(val) => $emit('cancelChat', val)"
              >
              </ragDatePickerMobile>
              <places-reservation
                v-else-if="message.supportLike && message.sender === 'bot' && message.msg === 'bookSeatCardList' && !$isMobile"
                :list='message.places'
                @renderTableComplete='scrollToBottom'
                :msg-id='message.msgId'
                :message-data='message'
                :language="message.language"
                :immediately-render='message.immediatelyRender'
                @refreshAnswer='refreshAnswer(message)'
                @reservation='reservation'
              >
              </places-reservation>
              <PlacesReservationMobile
                v-else-if="message.supportLike && message.sender === 'bot' && message.msg === 'bookSeatCardList' && $isMobile"
                :list='message.places'
                @renderTableComplete='scrollToBottom'
                :msg-id='message.msgId'
                :message-data='message'
                :language="message.language"
                :immediately-render='message.immediatelyRender'
                @refreshAnswer='refreshAnswer(message)'
                @reservation='reservation'
              >
              </PlacesReservationMobile>
              <city-building-select
                v-else-if="!$isMobile && message.supportLike && message.sender === 'bot' && message.msg === 'buildingComponent'"
                :msg-id='message.msgId'
                :list='message.places'
                :language="message.language"
                @renderTableComplete='scrollToBottom'
                :immediately-render='message.immediatelyRender'
                :message-data='message'
                @refreshAnswer='refreshAnswer(message)'
                @selectBuildingChange='selectBuildingChange'
                @cancelChat="(val) => $emit('cancelChat', val)">
              </city-building-select>
              <MobileBuilding
                v-else-if="$isMobile && message.supportLike && message.sender === 'bot' && message.msg === 'buildingComponent'"
                :msg-id='message.msgId'
                :list='message.places'
                :language="message.language"
                @renderTableComplete='scrollToBottom'
                :immediately-render='message.immediatelyRender'
                :message-data='message'
                @refreshAnswer='refreshAnswer(message)'
                @selectBuildingChange='selectBuildingChange'
                @cancelChat="(val) => $emit('cancelChat', val)">
              </MobileBuilding>
            </div>
            <ticket-submit
              v-else-if="message.answerType === 'ticketSubmit'"
              :language="message.language"
              :submitDisabled="message.ticketSubmitDisabled"
              :title="message.title"
              :desc="message.desc"
            >
            </ticket-submit>

            <ticket-create-success
              v-else-if="message.answerType === 'ticketCreateSuccess'"
              :language="message.language"
              :ticket-number="message.ticketNumber"
              :ticket-link="message.ticketLink"
            ></ticket-create-success>

            <ticket-create-error
              v-else-if="message.answerType === 'ticketCreateError'"
              :language="message.language"
            ></ticket-create-error>

            <stream-out-put-content
              v-else-if="(message.type === 'markdown' || message.answerType === 'msg' ) && !$isMobile"
              :message='message'
              @refreshAnswer='refreshAnswer(message)'
              :language="message.language"
            >
            </stream-out-put-content>

            <StreamOutPutContentMobile
              v-else-if="(message.type === 'markdown' || message.answerType === 'msg') && $isMobile"
              :message='message'
              @refreshAnswer='refreshAnswer(message)'
              :language="message.language"
            >
            </StreamOutPutContentMobile>

            <Thinking
              v-else-if="message.type === 'thinking' && !$isMobile"
              :user-question="message.text"
              :search-complete="message.searchComplete"
              :language="message.language"
              @completed="$emit('thinkingCompleted')"
            ></Thinking>

            <ThinkingMobile
              v-else-if="message.type === 'thinking' && $isMobile"
              :user-question="message.text"
              :search-complete="message.searchComplete"
              :language="message.language"
              @completed="$emit('thinkingCompleted')"
            ></ThinkingMobile>
            <div v-else class='black--text flex-wrap d-flex align-center'>
              <div>
                <div class='mr-2 user-message'>
                  <div>
                    <span style='color: #100d1b; font-size: 16px'>{{ message.text }}</span>
                  </div>
                  <div v-if='message.errorMsg' style='font-size: 13px'>
                    <br />
                    <div>错误日志如下：</div>
                    <div>{{ message.errorMsg }}</div>
                  </div>
                </div>
                <message-box
                  v-if="message.sender === 'bot' && message.type !== 'timeoutPrompt'"
                  :msg-id='message.msgId'
                  :message='message'
                  class='mt-2'
                  :like-type='message.likeType'
                  @refreshAnswer='refreshAnswer(message)'
                ></message-box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if='loading' class='text-center thinking-dots text-h3'>
      <span>.</span><span>.</span><span>.</span>
    </div>
  </div>
</template>
<script>
import PlacesReservation from '@/modules/chat/components/PlacesReservation.vue'
import BookingAwaitingApproval from '@/modules/chat/components/BookingAwaitingApproval.vue'
import BookingAwaitingApprovalMobile from '@/modules/chat/view/chatbot/mobile/component/BookingAwaitingApprovalMobile'
import PlacesReservationMobile from '@/modules/chat/view/chatbot/mobile/component/PlacesReservationMobile'
import BookingSuccess from '@/modules/chat/components/BookingSuccess.vue'
import BookingSuccessMobile from '@/modules/chat/view/chatbot/mobile/component/BookingSuccessMobile.vue'
import CitySelect from '@/modules/chat/components/CitySelect.vue'
import CityBuildingSelect from '@/modules/chat/components/CityBuildingSelect.vue'
import ragDatePicker from '@/modules/chat/components/ragDatePicker.vue'
import ragDatePickerMobile from '@/modules/chat/view/chatbot/mobile/component/ragDatePickerMobile.vue'
import MessageBox from '@/modules/chat/components/MessageBox.vue'
import StreamOutPutContent from '@/modules/chat/components/StreamOutPutContent.vue'
import StreamOutPutContentMobile from '@/modules/chat/view/chatbot/mobile/component/StreamOutPutContentMobile.vue'
import BookedRoom from '@/modules/chat/components/BookedRoom.vue'
import BookedRoomMobile from '@/modules/chat/view/chatbot/mobile/component/BookedRoomMobile.vue'
import CancelBookedNoticeCard from '@/modules/chat/components/CancelBookedNoticeCard.vue'
import CancelBookedNoticeCardMobile from '@/modules/chat/view/chatbot/mobile/component/CancelBookedNoticeCardMobile'
import ErrorBookedNoticeCardMobile from '@/modules/chat/view/chatbot/mobile/component/ErrorBookedNoticeCardMobile'
import { saveComponentSelectionValue } from '@/modules/chat/api/index'
import MessagePrompt from '@/modules/chat/components/MessagePrompt.vue'
import TicketSubmit from '@/modules/chat/view/chatbot/component/ITSMTicket/TicketSubmit'
import TicketCreateSuccess from '@/modules/chat/view/chatbot/component/ITSMTicket/TicketCreateSuccess'
import TicketCreateError from '@/modules/chat/view/chatbot/component/ITSMTicket/TicketCreateError'
import Thinking from '@/components/Thinking'
import ThinkingMobile from '@/modules/chat/view/chatbot/mobile/component/ThinkingMobile'
import MobileBuilding from '@/modules/chat/view/chatbot/mobile/component/Building'

export default {
  components: {
    StreamOutPutContent,
    ragDatePicker,
    CityBuildingSelect,
    CitySelect,
    BookingSuccess,
    PlacesReservation,
    BookingAwaitingApprovalMobile,
    PlacesReservationMobile,
    MessageBox,
    BookingAwaitingApproval,
    BookedRoom,
    CancelBookedNoticeCard,
    MessagePrompt,
    TicketSubmit,
    TicketCreateSuccess,
    Thinking,
    ThinkingMobile,
    MobileBuilding,
    CancelBookedNoticeCardMobile,
    ErrorBookedNoticeCardMobile,
    BookingSuccessMobile,
    ragDatePickerMobile,
    StreamOutPutContentMobile,
    BookedRoomMobile,
    TicketCreateError,
  },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  data() {
    return {}
  },
  methods: {
    refreshAnswer(message) {
      this.$emit('refreshAnswer', message)
    },
    reservation(data) {
      this.$emit('reservation', data)
    },
    scrollToBottom() {
      this.$emit('scrollToBottom')
    },
    async saveComponentSelection(answerId, value) {
      await saveComponentSelectionValue({ id: answerId, componentSelectionValue: value })
    },
    async selectBuildingChange(item) {
      let message = this.language === 'chinese' ? `楼号: ${item.buildindAliasName}` : `Building Name: ${item.buildindValue}`
      this.titlePrefix = `${item.cityValue}-${item.buildindValue}`
      await this.saveComponentSelection(item.answerId, JSON.stringify({ buildindValue: item.buildindValue }))
      this.$emit('componentEventHandle', {
        message: message, ...item,
        custom: true,
        queryType: 'component',
        building_number: item.buildindAliasName || item.buildindValue,
      })
    },
    cancelBookingCompletedEmit(data) {
      this.$emit('cancelBookingCompletedEmit', data)
    },
    async selectCityChange(item) {
      let message = this.language === 'chinese' ? `预订城市：${item.aliasName}` : `select the location：${item.cityName}`
      this.titlePrefix = `${item.cityName}`
      await this.saveComponentSelection(item.answerId, JSON.stringify({ cityName: item.cityName }))
      this.$emit('componentEventHandle', {
        message: message, ...item,
        custom: true,
        queryType: 'component',
        city: item.cityName,
        cityValue: item.cityName,
      })
    },
    async getDataRange(val) {
      let message = this.language === 'chinese' ? `起始时间为${val[0]}--结束时间为${val[1]}` : `StartDate: ${val[0]}--EndDate:${val[1]}`
      await this.saveComponentSelection(val[2], JSON.stringify({ startDateTime: val[0], endDateTime: val[1] }))
      this.$emit('componentEventHandle', {
        message: message,
        startDateTime: val[0],
        endDateTime: val[1],
        custom: true,
        queryType: 'component',
      })
    },
  },
}
</script>
<style scoped>
.chat-container {
  display: flex;
  flex-direction: column;
}

.user-message {
  /*max-width: 730px;*/
  border-radius: 16px 4px 16px 16px;
  background: #e6dcff;
  word-wrap: break-word;
  white-space: pre-wrap;
  font-family: Graphik, sans-serif;
  padding: 16px;
  text-align: left;
  filter: drop-shadow(0px 2px 4px rgba(149, 145, 151, .4));
}

.message-list {
  overflow-y: auto;
  padding: 1em;
  overflow-x: hidden;
}

.message.user {
  text-align: right;
}

.message.bot {
  text-align: left;
}

.grow {
  flex-grow: 1;
}

.thinking-container {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #333;
}

.dot {
  margin: 0 4px;
  animation: bounce 1.4s infinite ease-in-out;
}

/* 思考中的三点动画 */
.thinking-dots {
  font-size: 1.5rem;
  color: #757575;
}

.thinking-dots span {
  opacity: 0;
  animation: fadeInOut 1s infinite;
}

.thinking-dots span:nth-child(2) {
  animation-delay: 0.3s;
}

.thinking-dots span:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes fadeInOut {
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
</style>
